// exports FaxRequestDocumentType - an immutable object 'enum'
// usage: import { FaxRequestDocumentType } from '../../enums/FaxRequestDocumentType';
const faxRequestDocumentType = {
    PracticeValidationFile : 1,
    AlertPackage : 2
};
Object.freeze(faxRequestDocumentType);
export const FaxRequestDocumentType = faxRequestDocumentType;